import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {GoalType} from '../../models/goal-type';

@Injectable({
  providedIn: 'root'
})
export class GoalTypeService extends AbstractModelService<GoalType> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/goal-type', GoalType);
  }
}
